import { IUser } from 'core-components/sitebuilder/models/IUser'

import { IAudienceCondition } from '../../VisualAudienceExtended'

import { checkAnyIntersect } from './checkAnyIntersect'

export const checkIsUserAllowedByCondition = (user: IUser, condition: IAudienceCondition) => {
  if (condition.Country && !checkAnyIntersect(condition.Country, user.countries)) {
    return false
  }

  if (condition.HpOrg && !checkAnyIntersect(condition.HpOrg, user.hpOrgs)) {
    return false
  }

  if (condition.GeoMarket && !checkAnyIntersect(condition.GeoMarket, user.geoMarkets)) {
    return false
  }

  if (condition.UserRoles && !checkAnyIntersect(condition.UserRoles, user.roleIds)) {
    return false
  }

  if (condition.Email && !checkAnyIntersect(condition.Email, [user.email])) {
    return false
  }

  return true
}
